import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, EnvelopeSimple, ShieldCheck } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

const sitePrivacySections = [
  {
    title: "Titolare del trattamento",
    body: ["Il Titolare del trattamento è:"],
    details: [
      "ZeroCinqueZero",
      "Sede: Viale dei Caduti, 109 Legnago VR",
      "E-mail: info@zerocinquezero.it",
      "PEC: legal@pec.zerocinquezero.it",
    ],
  },
  {
    title: "Tipologie di dati trattati",
    body: ["Il sito può trattare le seguenti categorie di dati personali."],
    subsections: [
      {
        title: "Dati forniti volontariamente dall’utente",
        body: [
          "Attraverso il modulo di contatto presente sul sito, l’utente può inviare dati personali quali nome, cognome, indirizzo e-mail, numero di telefono, azienda, oggetto della richiesta e contenuto del messaggio.",
          "L’invio di tali dati è facoltativo, ma necessario per consentire al Titolare di rispondere alla richiesta inviata dall’utente.",
        ],
      },
      {
        title: "Dati tecnici di navigazione",
        body: [
          "I sistemi informatici e le procedure software preposte al funzionamento del sito possono acquisire, durante il normale esercizio, alcuni dati tecnici la cui trasmissione è implicita nell’uso dei protocolli di comunicazione Internet.",
          "Tali dati possono includere, a titolo esemplificativo, indirizzi IP, tipo di browser, sistema operativo, nome di dominio e indirizzi dei siti dai quali è stato effettuato l’accesso. Tali dati sono utilizzati esclusivamente per finalità tecniche, di sicurezza e di corretto funzionamento del sito.",
        ],
      },
    ],
  },
  {
    title: "Finalità del trattamento",
    body: ["I dati personali raccolti tramite il sito sono trattati per le seguenti finalità:"],
    list: [
      "rispondere alle richieste inviate tramite il modulo di contatto;",
      "fornire informazioni sui servizi richiesti dall’utente;",
      "gestire eventuali comunicazioni successive correlate alla richiesta ricevuta;",
      "garantire il corretto funzionamento tecnico del sito;",
      "adempiere a eventuali obblighi di legge o richieste delle autorità competenti.",
    ],
  },
  {
    title: "Base giuridica del trattamento",
    body: [
      "Il trattamento dei dati personali forniti tramite il modulo di contatto si basa sull’esecuzione di misure precontrattuali o contrattuali richieste dall’interessato, ai sensi dell’art. 6, par. 1, lett. b) del GDPR.",
      "Il trattamento dei dati tecnici necessari al funzionamento del sito si basa sul legittimo interesse del Titolare a garantire la sicurezza, la stabilità e il corretto funzionamento del sito, ai sensi dell’art. 6, par. 1, lett. f) del GDPR.",
      "Eventuali trattamenti necessari per adempiere a obblighi di legge si basano sull’art. 6, par. 1, lett. c) del GDPR.",
    ],
  },
  {
    title: "Modalità del trattamento",
    body: [
      "Il trattamento dei dati personali avviene con strumenti informatici e telematici, secondo principi di correttezza, liceità, trasparenza, minimizzazione e sicurezza.",
      "Il Titolare adotta misure tecniche e organizzative adeguate per proteggere i dati personali da accessi non autorizzati, perdita, divulgazione, modifica o distruzione non autorizzata.",
    ],
  },
  {
    title: "Comunicazione dei dati a terzi",
    body: [
      "I dati personali raccolti tramite il sito non saranno ceduti a terzi.",
      "I dati potranno essere trattati da soggetti che forniscono servizi tecnici o informatici necessari al funzionamento del sito, quali provider hosting, fornitori di servizi e-mail o manutentori tecnici, esclusivamente nei limiti necessari allo svolgimento delle rispettive attività e, ove previsto, in qualità di Responsabili del trattamento ai sensi dell’art. 28 GDPR.",
      "I dati potranno inoltre essere comunicati ad autorità pubbliche o soggetti legittimati, nei soli casi previsti dalla legge.",
    ],
  },
  {
    title: "Trasferimento dei dati fuori dall’Unione Europea",
    body: [
      "I dati personali non sono oggetto di trasferimento verso Paesi terzi al di fuori dell’Unione Europea, salvo che ciò sia necessario per l’utilizzo di servizi tecnici forniti da soggetti che garantiscano adeguate garanzie ai sensi degli artt. 44 e seguenti del GDPR.",
    ],
  },
  {
    title: "Periodo di conservazione",
    body: [
      "I dati inviati tramite il modulo di contatto sono conservati per il tempo necessario a gestire la richiesta dell’utente e le eventuali comunicazioni successive.",
      "In assenza di ulteriori rapporti contrattuali o obblighi di legge, i dati saranno conservati per un periodo massimo di 12 mesi dalla ricezione della richiesta, salvo necessità di ulteriore conservazione per tutela dei diritti del Titolare o adempimento di obblighi normativi.",
      "I dati tecnici di navigazione sono conservati per il tempo strettamente necessario al funzionamento del sito e alla gestione della sicurezza informatica.",
    ],
  },
  {
    title: "Diritti dell’interessato",
    body: ["L’utente può esercitare, nei casi previsti dal GDPR, i seguenti diritti:"],
    list: [
      "diritto di accesso ai dati personali;",
      "diritto di rettifica;",
      "diritto alla cancellazione;",
      "diritto alla limitazione del trattamento;",
      "diritto di opposizione;",
      "diritto alla portabilità dei dati, ove applicabile;",
      "diritto di proporre reclamo al Garante per la protezione dei dati personali.",
    ],
    afterList: ["Le richieste possono essere inviate al Titolare utilizzando i recapiti indicati nella presente informativa."],
  },
  {
    title: "Reclamo all’autorità di controllo",
    body: [
      "L’interessato ha diritto di proporre reclamo al Garante per la protezione dei dati personali qualora ritenga che il trattamento dei propri dati personali avvenga in violazione della normativa applicabile.",
    ],
  },
  {
    title: "Modifiche alla presente informativa",
    body: [
      "Il Titolare si riserva il diritto di modificare o aggiornare la presente informativa in qualsiasi momento. Le modifiche saranno pubblicate su questa pagina.",
    ],
  },
];

export default function SitePrivacyPolicyPage() {
  const [pointerStyle, setPointerStyle] = useState({ "--mouse-x": "50%", "--mouse-y": "18%" });

  useEffect(() => {
    document.title = "Privacy Policy | ZeroCinqueZero";
  }, []);

  const handlePointerMove = (event) => {
    const x = `${Math.round((event.clientX / window.innerWidth) * 100)}%`;
    const y = `${Math.round((event.clientY / window.innerHeight) * 100)}%`;
    setPointerStyle({ "--mouse-x": x, "--mouse-y": y });
  };

  return (
    <div className="app-shell min-h-screen overflow-x-hidden bg-[#050505] text-[#F5F5F7]" style={pointerStyle} onPointerMove={handlePointerMove} data-testid="site-privacy-policy-page">
      <div className="reactive-background" data-testid="site-privacy-reactive-background-layer" aria-hidden="true">
        <span className="reactive-glow reactive-glow-primary" />
        <span className="reactive-glow reactive-glow-accent" />
        <span className="reactive-scanline" />
      </div>

      <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-[#050505]/70 backdrop-blur-xl" data-testid="site-privacy-header">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8 lg:px-12">
          <Link to="/" className="group flex items-center gap-3" data-testid="site-privacy-logo-home-link" aria-label="Torna alla home ZeroCinqueZero">
            <span className="grid h-10 w-10 place-items-center border border-white/15 bg-white text-sm font-black text-black transition-transform duration-300 group-hover:-translate-y-0.5" data-testid="site-privacy-logo-mark">
              050
            </span>
            <span className="hidden text-sm font-semibold uppercase tracking-[0.24em] text-white sm:inline" data-testid="site-privacy-brand-name">
              ZeroCinqueZero
            </span>
          </Link>
          <Button asChild variant="outline" className="h-11 rounded-none border-white/15 bg-transparent px-5 text-white transition-[border-color,transform,background-color] duration-300 hover:-translate-y-0.5 hover:border-white/35 hover:bg-white/10" data-testid="site-privacy-back-home-button">
            <Link to="/"><ArrowLeft size={17} /> Home</Link>
          </Button>
        </div>
      </header>

      <main className="px-5 pb-16 pt-32 sm:px-8 sm:pb-24 sm:pt-40 lg:px-12" data-testid="site-privacy-main-content">
        <div className="mx-auto max-w-5xl">
          <section className="mb-12 border border-white/10 bg-[#0F0F13]/80 p-6 shadow-2xl backdrop-blur-xl sm:p-10" data-testid="site-privacy-hero-card">
            <p className="mb-5 inline-flex items-center gap-3 border border-white/10 bg-white/[0.03] px-4 py-2 text-xs font-semibold uppercase tracking-[0.24em] text-[#8B8B96]" data-testid="site-privacy-eyebrow">
              <ShieldCheck size={18} weight="fill" className="text-[#0047FF]" /> Informativa sito web
            </p>
            <h1 className="text-5xl font-black leading-[0.92] tracking-[-0.065em] text-white sm:text-6xl lg:text-7xl" data-testid="site-privacy-title">
              Privacy Policy
            </h1>
            <p className="mt-7 max-w-3xl text-base leading-8 text-[#B8B8C2]" data-testid="site-privacy-intro">
              Informativa sul trattamento dei dati personali resa ai sensi dell’art. 13 del Regolamento UE 2016/679, “GDPR”, agli utenti che consultano il sito web www.zerocinquezero.it.
            </p>
            <a href="mailto:info@zerocinquezero.it" className="mt-8 inline-flex items-center gap-3 text-sm font-semibold text-white transition-colors duration-300 hover:text-[#7EA0FF]" data-testid="site-privacy-email-link">
              <EnvelopeSimple size={22} weight="fill" className="text-[#FF2E00]" /> info@zerocinquezero.it
            </a>
          </section>

          <div className="space-y-5" data-testid="site-privacy-sections-list">
            {sitePrivacySections.map((section, index) => (
              <article key={section.title} className="border border-white/10 bg-[#0F0F13]/75 p-6 backdrop-blur-xl sm:p-8" data-testid={`site-privacy-section-${index + 1}`}>
                <h2 className="text-2xl font-bold tracking-[-0.04em] text-white" data-testid={`site-privacy-section-title-${index + 1}`}>{section.title}</h2>
                <div className="mt-5 space-y-4 text-base leading-8 text-[#B8B8C2]" data-testid={`site-privacy-section-body-${index + 1}`}>
                  {section.body?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                  {section.details && (
                    <div className="border border-white/10 bg-[#050505] p-5 text-white" data-testid={`site-privacy-section-details-${index + 1}`}>
                      {section.details.map((detail) => <p key={detail}>{detail}</p>)}
                    </div>
                  )}
                  {section.subsections?.map((subsection) => (
                    <div key={subsection.title} className="border-l border-[#0047FF]/70 pl-4" data-testid={`site-privacy-subsection-${subsection.title.toLowerCase().replaceAll(" ", "-")}`}>
                      <h3 className="text-lg font-semibold text-white">{subsection.title}</h3>
                      <div className="mt-3 space-y-3">
                        {subsection.body.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                      </div>
                    </div>
                  ))}
                  {section.list && (
                    <ul className="space-y-3 pl-5" data-testid={`site-privacy-section-list-${index + 1}`}>
                      {section.list.map((item) => <li key={item} className="list-disc marker:text-[#0047FF]">{item}</li>)}
                    </ul>
                  )}
                  {section.afterList?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                </div>
              </article>
            ))}
          </div>

          <p className="mt-8 border border-[#0047FF]/40 bg-[#0047FF]/10 p-5 text-sm font-semibold uppercase tracking-[0.18em] text-[#DDE6FF]" data-testid="site-privacy-last-updated">
            Ultimo aggiornamento: 28/04/2026
          </p>
        </div>
      </main>

      <footer className="border-t border-white/10 px-5 py-8 text-sm text-[#8B8B96] sm:px-8 lg:px-12" data-testid="site-privacy-footer">
        <div className="mx-auto flex max-w-5xl flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="site-privacy-footer-brand">© ZeroCinqueZero — Software house italiana · P.IVA 04830250231</p>
          <div className="flex flex-wrap gap-5" data-testid="site-privacy-footer-links">
            <Link to="/cookie-policy" className="transition-colors duration-300 hover:text-white" data-testid="site-privacy-footer-cookie-policy-link">Cookie Policy</Link>
            <Link to="/" className="transition-colors duration-300 hover:text-white" data-testid="site-privacy-footer-home-link">Torna alla home</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}